import React, { useEffect } from "react";
import { useIntl } from "react-intl";

import { DefaultModal, FooterComponent, Text } from '@housebets/housebets-x-package';
import { TKey } from "@anton.bobrov/react-components";

import { langOpt } from "app/components/constants";

import { useFooterData } from "./hooks/useFooterData";
import { useDispatch } from "react-redux";
// import {useChangeLanguage} from "app/hooks/useChangeLanguage";
import { setLocale } from "app/store/slices/config";
import { useChangeLanguage } from "app/hooks/useChangeLanguage";
import { useAppSelector } from "app/hooks/useAppSelector";
import { useParams } from "react-router";

export const Footer: React.FC = () => {
    const {
        casinoLinks,
        contactUsInfo,
        promoLinks,
        sportsLinks,
        supportLinks,
        isReadMoreModalOpen,
        setIsReadMoreModalOpen
    } = useFooterData();
    // const { $t } = useIntl();
    const { formatMessage: $t } = useIntl();
    const {lang} = useParams();

    const dispatch = useDispatch();
    const locale = useAppSelector((state) => state.config.locale);
    const changeLanguage = useChangeLanguage();

    const langHandler = (value: TKey[]) => {
        const selLocal = value[0] + "";
        if (locale === selLocal) return;
        dispatch(setLocale(selLocal));
        changeLanguage(selLocal === 'en' ? selLocal : selLocal);
    };

    const localeCurrent = useAppSelector((state) => state.config.locale);
    
    return (
        <>
            <FooterComponent.Footer
                casinoLinks={casinoLinks}
                contactUsInfo={contactUsInfo}
                promoLinks={promoLinks}
                sportsLinks={sportsLinks}
                supportLinks={supportLinks}
                copyright={$t({ id: "HousebetsALLRIGHTSRESERVED2023" }, { y: new Date().getFullYear() })}
                langOptions={langOpt}
                onLangChange={(v) => langHandler([v])}
                textMiddle={{
                    left: $t({id: "Footer.middle.left"}),
                    right: $t({id: "Footer.middle.right"}),
                    link: "https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJaXR5WmpnMFdHWXdMM1k0U0dOUk1XMUJhR2REYTJjOVBTSXNJblpoYkhWbElqb2libTh5WnlzNFkzWlhhSGM1ZVhCaVlWcDNVVlZYUVQwOUlpd2liV0ZqSWpvaU1EQXdZamRoTkRKa1pXVTNZalF5TlRFeVpHWTNNelJsT0dKa01USmhZVEJoTW1ReVlqQTVORFF4T1dJeFlqQTNNR0ZoT1RVd1l6UTBaVFprTVRFME1TSXNJblJoWnlJNklpSjk=",
                }}
                selectedLang={localeCurrent}
                animations={{
                    "data-aos": 'fade-up-sm',
                    "data-aos-delay": '400',
                    "data-aos-duration": '1000',
                }}
            />
            <DefaultModal
                isOpen={isReadMoreModalOpen}
                onClose={() => setIsReadMoreModalOpen(false)}
                title={$t({ id: "ReadMore" })}
            >
                <Text v2>
                    <p>
                        {$t({ id: "WebDescFull" })}
                    </p>
                </Text>
            </DefaultModal>
        </>
    );
};

Footer.displayName = "Layout.Footer";
